import React, { useState, useCallback, useEffect } from 'react';
import { supabase } from '../../services/supabase';


const FilmGrid = ({
  films,
  onSelectFilm,
}) => {
  // Thêm state để theo dõi video hiện tại
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  // Triển khai hàm playNextVideo
  const playNextVideo = useCallback(() => {
    // Tính toán index của video tiếp theo
    const nextIndex = currentVideoIndex + 1;
    
    // Kiểm tra xem còn video tiếp theo không
    if (nextIndex < films.length) {
      // Cập nhật index hiện tại
      setCurrentVideoIndex(nextIndex);
      
      // Lấy video tiếp theo từ danh sách
      const nextVideo = films[nextIndex];
      
      // Gọi callback để thông báo video được chọn
      if (onSelectFilm) {
        onSelectFilm(nextVideo);
      }
      
      // Cuộn lên đầu trang (tuỳ chọn)
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Lưu ID video đang xem vào localStorage (tuỳ chọn)
      if (nextVideo.id) {
        localStorage.setItem('lastViewedFilmId', nextVideo.id);
      }
    }
  }, [currentVideoIndex, films, onSelectFilm]);


  if (!films.length) {
    return (
      <div className="text-center text-gray-400 py-8">
        Không có phim nào trong thể loại này
      </div>
    );
  }


  const updateFilmViews = async (filmId) => {
    // Lấy số lượng view hiện tại
    const { data: filmData, error: fetchError } = await supabase
      .from('film')
      .select('views')
      .eq('id', filmId)
      .single();
    debugger;
    if (fetchError) {
      console.error('Error fetching current views:', fetchError);
      return;
    }

    // Tăng số lượng view lên 1
    const newViews = filmData.views + 1;

    // Cập nhật số lượng view
    const { data, error } = await supabase
      .from('film')
      .update({ views: newViews })
      .eq('id', filmId);

    if (error) {
      console.error('Error updating views:', error);
    } else {
      console.log('Views updated successfully:', data);
    }
  };

  const handleVideoClick = (film, index) => {
    setCurrentVideoIndex(index);
    onSelectFilm(film, playNextVideo);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    localStorage.setItem('lastViewedFilmId', film.id);
  };

  return (
    <div>
      <div className="w-full bg-gray-800 p-5 rounded-lg no-scroll-y" style={{ height: '400px', overflowY: 'scroll' }}>
        <h3 className="text-white pb-2.5">Film List</h3>
        <ul className="text-gray-400 space-y-2">
          {films.map((video, index) => (
            <li
              key={index}
              className={`cursor-pointer hover:text-white flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-600 transition duration-200 ${
                index === currentVideoIndex ? 'bg-gray-700 text-white' : ''
              }`}
              onClick={() => handleVideoClick(video, index)}
            >
              <div className="w-16 h-9 bg-gray-500 rounded-lg flex-shrink-0"></div> {/* Placeholder for thumbnail */}
              <span className="flex-grow">{video.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FilmGrid;
